import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import EncuestaMostrador from './EncuestaMostrador';
import EncuestaServicio from './EncuestaServicio';
import LoadingAnimation from '../../../components/anims/LoadingAnimation';

const Encuesta = () => {
    const { token } = useParams();  // Usamos token desde los params
    const [tipoEncuesta, setTipoEncuesta] = useState(null);
    const [encuesta, setEncuesta] = useState(null);
    const [error, setError] = useState(false);  // Estado para manejar si no se encuentra la encuesta

    useEffect(() => {
        const fetchEncuesta = async () => {
            try {
                const response = await axios.get(`/api/encuestas/${token}`);
                
                // Verificar si no se encontró la encuesta
                if (!response.data) {
                    setError(true);
                    return;
                }
                const encuestaData = response.data;
                setEncuesta(encuestaData);
                setTipoEncuesta(encuestaData.tipoEncuesta);
            } catch (error) {
                console.error('Error fetching encuesta:', error);
                setError(true);
            }
        };
        fetchEncuesta();
    }, [token]);

    // Si no se encuentra la encuesta, mostrar el mensaje
    if (error) {
        return <div>La encuesta que intenta diligenciar ya no existe.</div>;
    }

    if (!encuesta) {
        return <LoadingAnimation />;
    }

    // Verificar si la encuesta ya fue respondida
    if (encuesta.respondida === 1) {
        return <div>La encuesta ya fue diligenciada.</div>;
    }

    if (tipoEncuesta === 3) {
        return (
            <div className="p-4 max-w-lg mx-auto text-center space-y-4">
                <h2 className="text-xl font-bold text-yellow-600">Encuesta por WhatsApp</h2>
                <p>Esta compra se evalúa por mensaje de WhatsApp. Revisa el chat de Osorio Repuestos y responde la encuesta que te enviamos.</p>
            </div>
        );
    }

    return (
        <div className="p-4 max-w-3xl mx-auto">
            <p className="mb-4 text-sm text-gray-600 bg-yellow-50 border border-yellow-200 rounded p-3">
                Preferimos que respondas por WhatsApp. Este formulario web solo aplica si llegaste por un enlace antiguo de correo.
            </p>
            {tipoEncuesta === 1 && (
                <EncuestaMostrador encuesta={encuesta} token={token} nombreVendedor={encuesta.nombreVendedor} nombreCliente={encuesta.nombreCliente}/>
            )}
            {tipoEncuesta === 2 && (
                <EncuestaServicio encuesta={encuesta} token={token} nombreMecanico={encuesta.nombre_mecanico} nombreVendedor={encuesta.nombreVendedor} nombreCliente={encuesta.nombreCliente}/>
            )}
        </div>
    );
};

export default Encuesta;
